import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Heights } from './index';

export const StyledTopSpacer = styled('div')`
  margin-bottom: ${pxToRem(2)};
`;

// padding-top: 0.05px prevents this from collapsing into the web banner spacer
// while still allowing the hero blocks margins to collapse
export const NavbarSpacer = styled('div')<{ heights: Heights }>`
  padding-top: 0.05px;
  margin-bottom: ${({ heights }) => pxToRem(heights && heights[0] || 0)};
  ${({ heights }) =>
    heights?.mobile
      ? `${mediaQueries.mobile} {
          margin-bottom: ${pxToRem(heights.mobile)};
        }`
      : ``}
  ${({ heights }) =>
    heights?.tablet
      ? `${mediaQueries.tablet} {
          margin-bottom: ${pxToRem(heights.tablet)};
        }`
      : ``}
  ${({ heights }) =>
    heights?.desktop
      ? `${mediaQueries.desktop} {
            margin-bottom: ${pxToRem(heights.desktop)};
          }`
      : ``}
  ${({ heights }) =>
    heights?.max
      ? `${mediaQueries.max} {
          margin-bottom: ${pxToRem(heights.max)};
        }`
      : ``}
`;

export const WebBannerSpacer = styled('div')<{ bannerHeights: Heights }>`
  padding-top: 0.05px;
  margin-bottom: ${({ bannerHeights = {} }) => pxToRem(bannerHeights && bannerHeights[0] || 0)};
  ${({ bannerHeights = {} }) =>
    bannerHeights?.mobile
      ? `${mediaQueries.mobile} {
          margin-bottom: ${pxToRem(bannerHeights.mobile)};
        }`
      : ``}
  ${({ bannerHeights = {} }) =>
    bannerHeights?.tablet
      ? `${mediaQueries.tablet} {
          margin-bottom: ${pxToRem(bannerHeights.tablet)};
        }`
      : ``}
  ${({ bannerHeights = {} }) =>
    bannerHeights.desktop
      ? `${mediaQueries.desktop} {
            margin-bottom: ${pxToRem(bannerHeights.desktop)};
          }`
      : ``}
  ${({ bannerHeights = {} }) =>
    bannerHeights.max
      ? `${mediaQueries.max} {
          margin-bottom: ${pxToRem(bannerHeights.max)};
        }`
      : ``}
`;
